"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleSpecSchema = void 0;
const zod_1 = require("zod");
exports.ArticleSpecSchema = zod_1.z.enum(['espoolOnly', 'espoolReady', 'Chainflex', 'Readycable', 'PullWire', 'erkReady', 'SmartPlasticsOnly', 'SmartPlasticsECPSensor', 'SmartPlasticsECPDummy', 'SmartPlasticsModule', 'SmartPlasticsSMSModule', 'SmartPlasticsSimCard']);
exports.default = exports.ArticleSpecSchema;
//# sourceMappingURL=ArticleSpecSchema.js.map